import AssistantPill from './AssistantPill';
// Minimal translator: echoes the last dot-segment as an uppercase-ish label so
// the story renders readable pill text without pulling in the real i18n bundle.
const DICT = {
    'rules.surface.ia': 'IA',
    'rules.surface.ipa': 'IPA'
};
const t = (key) => { var _a; return (_a = DICT[key]) !== null && _a !== void 0 ? _a : key; };
const meta = {
    title: 'Features/Settings/TenantKnowledgeBase/AssistantPill',
    component: AssistantPill,
    parameters: {
        layout: 'padded'
    },
    args: {
        t
    }
};
export default meta;
/**
 * A single surface — IPA only.
 */
export const Ipa = {
    args: {
        surfaces: ['ipa']
    }
};
/**
 * Both surfaces — IPA and IA pills rendered side by side.
 */
export const BothSurfaces = {
    args: {
        surfaces: ['ipa', 'ia']
    }
};
